export class UserSettingModel {
  id = 0;
  responseMasterUserId = 0;
  dailyLetterTarget = 0;
}
